import { format } from 'date-fns';
import i18n from '@/i18n';

export function formatTaskTime(createdAt) {
  if (!createdAt) return '—';
  try {
    const raw = String(createdAt);
    const d = raw.includes('T') ? new Date(raw) : new Date(raw.replace(' ', 'T'));
    return format(d, 'yyyy-MM-dd HH:mm:ss');
  } catch {
    return String(createdAt);
  }
}

function t(key, options) {
  return i18n.t(`workbench:${key}`, options);
}

export function getBatchTaskStatusUi(status, result) {
  const s = String(status || '').toLowerCase();
  const batchPhase = String(result?.batchPhase || '').toLowerCase();
  const agentPhase = String(result?.agentVideoPhase || '').toUpperCase();
  const terminal = ['failed', 'success', 'succeed', 'completed', 'partial', 'canceled', 'cancelled'].includes(s);
  if (batchPhase === 'cancelled' || batchPhase === 'canceled' || s === 'canceled' || s === 'cancelled') {
    return { label: t('studioChrome.statusStopped'), className: 'partial' };
  }
  // 任务已失败/完成时，不能再被创建时留下的 batchPhase=queued 显示成「排队中」
  if (!terminal && (batchPhase === 'queued' || agentPhase === 'QUEUE_WAIT')) {
    return { label: t('studioChrome.statusQueued'), className: 'waiting' };
  }
  if (['succeed', 'success', 'completed'].includes(s)) {
    return { label: t('studioChrome.statusDone'), className: 'success' };
  }
  if (s === 'partial') return { label: t('studioChrome.statusStopped'), className: 'partial' };
  if (s === 'failed') return { label: t('studioChrome.statusFailed'), className: 'failed' };
  if (s === 'waiting') return { label: t('studioChrome.statusWaiting'), className: 'waiting' };
  if (['processing', 'executing', 'pending', 'new'].includes(s)) {
    return { label: t('studioChrome.statusRunning'), className: 'processing' };
  }
  return { label: status || '—', className: 'processing' };
}

function buildSuccessOfTotal(total, success, failed) {
  const base = t('studioChrome.successOfTotal', { success, total });
  return failed > 0 ? `${base}${t('studioChrome.failedExtra', { count: failed })}` : base;
}

export function buildTitleExtractHeroMeta(task) {
  const total = Math.max(Number(task?.total ?? task?.count ?? 0), 0);
  const success = Math.min(Math.max(Number(task?.successCount ?? 0), 0), total);
  const failedRaw = Number(task?.failedCount ?? 0);
  const failed = Math.min(Math.max(failedRaw, 0), Math.max(total - success, 0));

  return {
    metaItems: [
      { label: t('studioChrome.taskNo'), value: task?.id || '—' },
      { label: t('studioChrome.created'), value: formatTaskTime(task?.createdAt) },
      {
        label: t('studioChrome.extractProgress'),
        value: buildSuccessOfTotal(total, success, failed),
      },
    ],
    status: getBatchTaskStatusUi(task?.status, task?.result),
  };
}

export function buildBatchTaskHeroMeta(task, options = {}) {
  const total = Number(task?.total ?? task?.count ?? 0);
  const success = Number(task?.successCount ?? 0);
  const failed = Number(task?.failedCount ?? 0);
  const idLabel = options.idLabel || t('studioChrome.taskNo');
  const progressLabel = options.progressLabel || t('studioChrome.progressLabel');
  const displayId = options.displayId ?? task?.subAccount ?? task?.batchNo ?? task?.id ?? '—';

  return {
    metaItems: [
      { label: idLabel, value: displayId || '—' },
      { label: t('studioChrome.created'), value: formatTaskTime(task?.createdAt) },
      {
        label: progressLabel,
        value: buildSuccessOfTotal(total, success, failed),
      },
    ],
    status: getBatchTaskStatusUi(task?.status, task?.result),
  };
}
